import {configureStore} from "@reduxjs/toolkit";
import contactReducer from '../redux/contact';
import globalReducer from '../redux/global';
import homeReducer from '../redux/home';
import archReducer from '../redux/arch';
import writingReducer from '../redux/writing';
import postReducer from '../redux/post';


const store = configureStore({
    reducer: {
        postReducer,
        arch: archReducer,
        writing: writingReducer,
        globalReducer,
        home: homeReducer,
        contact: contactReducer,
    },
    // middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger)
})


export default store

